import React from "react";
import { Box, Typography, Grid, CardMedia } from "@material-ui/core";

const HeaderPrintAll = () => {
  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Box align="center">
              <CardMedia
                component="img"
                src="/bmcdc_logo.png"
                alt="bmcdc"
                style={{ width: 100 }}
              />
            </Box>
          </Grid>

          <Grid item xs={8}>
            <Box align="center">
              <Typography variant="h3">
                <b>GLOBAL TELEMEDICINE CORP, INC.</b>
              </Typography>
              <Typography>
                <b>MATINA PANGI, DAVAO CITY</b>
              </Typography>
              <Typography>
                <b>Tel. 000-0000 Telefax: 000-0000</b>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={2}>
            <Box align="center">
              <CardMedia
                component="img"
                src="/bmcdc_medical.png"
                alt="bmcdc"
                style={{ width: 100 }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default HeaderPrintAll;
